import { Box, Flex, HStack, Text, keyframes } from "@chakra-ui/react";
import { CHAT_COLORS } from "./chatStyles";
import { ChatAvatar } from "./ChatAvatar";

const pulse = keyframes`
  0%, 80%, 100% { opacity: 0.25; transform: translateY(0); }
  40% { opacity: 1; transform: translateY(-2px); }
`;

/** "DOOSAN AI is thinking…" row shown while a reply is on its way. */
export const ChatTypingIndicator = ({ label }: { label: string }) => (
  <Flex align="center" gap="10px" mb={6} aria-live="polite">
    <ChatAvatar />
    <HStack
      spacing="10px"
      px="14px"
      py="8px"
      borderRadius="999px"
      bg="#F8FAFC"
      border={`1px solid ${CHAT_COLORS.border}`}
    >
      <HStack spacing="4px">
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            w="6px"
            h="6px"
            borderRadius="full"
            bg={CHAT_COLORS.brand}
            animation={`${pulse} 1.2s ease-in-out ${i * 0.15}s infinite`}
          />
        ))}
      </HStack>
      <Text fontSize="13px" color={CHAT_COLORS.muted}>
        {label}
      </Text>
    </HStack>
  </Flex>
);
